<template>
  <b-container class="mt-3">
    <router-view />
  </b-container>
</template>
